import React from "react";
import { SvgIcon } from "@mui/material";
import { ToggleableIconProps } from "../../../../types/IconProps";
import { useTheme } from "@mui/material/styles";
import { getIconColor } from "../../../../services/iconService";

const IconLicencePointsFour = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={sx} viewBox="0 0 300 300">
      <g style={{ fill: getIconColor(active, theme) }}>
        <path
          d="M29.485,287.127c-9.121-0.031-16.556-7.467-16.586-16.576V65.909c0-1.906,1.547-3.453,3.455-3.453
			c1.906,0,3.453,1.547,3.453,3.453V270.54c0.018,5.314,4.363,9.662,9.688,9.68h241.006c5.321-0.014,9.672-4.359,9.688-9.689V29.461
			c-0.018-5.318-4.367-9.666-9.697-9.678H29.496c-5.325,0.016-9.672,4.363-9.688,9.688v13.246c0,1.908-1.547,3.455-3.453,3.455
			c-1.908,0-3.455-1.547-3.455-3.455V29.459c0.03-9.117,7.459-16.551,16.563-16.586c0.008,0,0.017,0,0.022,0h241.018
			c9.126,0.021,16.566,7.457,16.598,16.576v241.088c-0.03,9.129-7.472,16.564-16.588,16.588H29.485V287.127z"
        />
        <path
          d="M163.321,205.42h16.408v-29.424h8.867v-13.578h-8.867V94.51h-17.679l-50.649,69.516v11.986h51.92v29.424
			V205.42z M163.321,162.387h-32.846l32.846-44.512v44.543V162.387z"
        />
      </g>
      <g>
        <path
          fill={theme.palette.primary.main}
          d="M266.124,269.565H33.874c-1.907,0-3.454-1.547-3.454-3.455c0-1.906,1.547-3.453,3.454-3.453H262.67V33.848
			c0-1.906,1.547-3.453,3.454-3.453s3.454,1.547,3.454,3.453V266.11C269.578,268.018,268.03,269.565,266.124,269.565z"
        />
      </g>
    </SvgIcon>
  );
};

export default IconLicencePointsFour;
